"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApparentMagnitudeMoon = void 0;
var distanceCalc_1 = require("../../utils/distanceCalc");
function getApparentMagnitudeMoon(distanceSun, distanceEarth, phaseAngle, isWaxing) {
    var signedPhaseAngle = isWaxing ? -1 * phaseAngle : phaseAngle;
    var V = 5 * (Math.log10(distanceSun) + Math.log10((0, distanceCalc_1.au2km)(distanceEarth) / 384400));
    if (phaseAngle >= 160) {
        V += -449.88
            + 7.1112 * phaseAngle
            - 0.037714 * Math.pow(phaseAngle, 2)
            + 0.000066667 * Math.pow(phaseAngle, 3);
    }
    if (phaseAngle >= 40 && phaseAngle < 160) {
        V += -12.07857
            + 0.002175199 * signedPhaseAngle
            + 0.0002859289 * Math.pow(signedPhaseAngle, 2)
            - 2.495124E-07 * Math.pow(signedPhaseAngle, 3)
            - 8.699235E-09 * Math.pow(signedPhaseAngle, 4)
            + 7.606291E-12 * Math.pow(signedPhaseAngle, 5)
            + 3.403311E-13 * Math.pow(signedPhaseAngle, 6);
    }
    if (signedPhaseAngle >= 0 && signedPhaseAngle < 40) {
        V += -12.861
            + 0.037 * phaseAngle
            - 0.00012 * Math.pow(phaseAngle, 2);
    }
    if (signedPhaseAngle > -40 && signedPhaseAngle < 0) {
        V += -12.85
            - 0.037 * signedPhaseAngle
            - 0.000235 * Math.pow(signedPhaseAngle, 2);
    }
    return V;
}
exports.getApparentMagnitudeMoon = getApparentMagnitudeMoon;
